// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UpgradeOverlay_upgradeText__DYH9a {
  font-size: 0.875rem;
}

@media screen and (min-width: 75em) {
  .UpgradeOverlay_upgradeText__DYH9a {
    font-size: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/reporting/components/CallHistoryTable/UpgradeOverlay.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;;AAEA;EACE;IACE,eAAA;EACF;AACF","sourcesContent":[".upgradeText {\n  font-size: 0.875rem;\n}\n\n@media screen and (min-width: 75em) {\n  .upgradeText {\n    font-size: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"upgradeText": `UpgradeOverlay_upgradeText__DYH9a`
};
export default ___CSS_LOADER_EXPORT___;
